

















































































import { Component, Vue } from 'vue-property-decorator'
import Slider from '../ui/Slider.vue'
import '@/icons/coloring-slider-sun'
import '@/icons/coloring-slider-house'
import '@/icons/coloring-slider-cloud'

@Component({
  components: {
    Slider
  }
})
export default class TabPhotoChromic extends Vue {
  private image: string = require('@/assets/images/tabs/photochromic/glass_grey.png')
  private alpha = 0.8
  private options: Array<{
    id: number,
    title: string,
    src: string,
    selected: boolean
  }> = [
    {
      id: 0,
      title: 'tab_photochromatic_grey',
      src: require('@/assets/images/tabs/photochromic/glass_grey.png'),
      selected: true
    },
    {
      id: 1,
      title: 'tab_photochromatic_brown',
      src: require('@/assets/images/tabs/photochromic/glass_brown.png'),
      selected: false
    },
    {
      id: 2,
      title: 'tab_photochromatic_green',
      src: require('@/assets/images/tabs/photochromic/glass_green.png'),
      selected: false
    }
  ]

  public onInput (input: number) {
    this.alpha = (input / 100)
  }

  private selectOption (index: number) {
    for (let i = 0; i < this.options.length; i++) {
      if (index === i) {
        this.options[i].selected = true
        this.image = this.options[i].src
      } else {
        this.options[i].selected = false
      }
    }
  }
}
